import React from "react";
import HackEtherScan from "../components/hacks/HackEtherScan";

import HackLayout from "../components/hacks/HackLayout";

const HackEtherScanPage = () => {
  return (
    <HackLayout activeId="2">
      <div className="space-y-12">
        <HackEtherScan
          teamName="Red Team"
          blockCollection="redTeamBlocks"
          transactionCollection="redTeamTransactions"
        />
        <HackEtherScan
          teamName="Blue Team"
          blockCollection="blueTeamBlocks"
          transactionCollection="blueTeamTransactions"
        />
      </div>
    </HackLayout>
  );
};

export default HackEtherScanPage;
